<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">清风论坛></span>
        <span @click="GoreportEvaluation">警示教育></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>枣阳市通报4起群众身边的不正之风和腐败问题典型案例</h1>
        <h2>
          来源：新华社
          <span class="mg-16">|</span>
          发布时间：2020-03-30&nbsp;13:30
        </h2>
        <h3>
          <b>1.枣阳市环城交管站原站长王昌学贪污问题。</b>
        </h3>
        <h3>2008年1月至2018年10月，王昌学利用担任环城交管站站长职务上的便利，私自收取单位房租费，未入单位财务账，将其中少部分用于支付单位外欠账，剩余款项据为已有。组织调查期间，王昌学如实交代违纪违法事实，主动上交违纪款。2019年12月，王昌学受到留党察看二年、政务降级处分。.11%。从村（社区）干部受处理具体案例来分析，两人或两人以上“抱团”违纪现象比较普遍。主要表现为以村支部书记、主任为核心，其他村组干部参与、共同“谋划”的利益“小团体”，成为违纪违法问题的高危群体。如，该市太平镇崔垱村、大王村从村支部书记到村委会委员，集体挪用粮食直补款、坐收坐支集体资金等，涉及村“两委”干部达5人。+体会交流+廉政党课”的方式召开了“一案一教育”警示教育大会，强化警示教育的感染力和说服力。</h3>
        <h3>
          <b>2.枣阳市杨垱镇仲庄村党支部委员、农经站长李小峰侵害群众利益问题。</b>
        </h3>
        <h3>2017年底，李小峰收取仲庄村七组村民栾某某家4人2018年城乡居民基本医疗保险费，但只缴纳了栾某某母亲本人的保险费，将余款据为己有。2018年9月，栾某某之子因病住院，因未缴纳基本医疗保险，不能报销相关费用，造成不良影响。案发后，李小峰将未缴纳的保险费退还栾某某，并承担了其子的住院医疗费用。2019年9月，李小峰受到党内警告处分。.76%，同比增长7.25%。主要原因是由于各地各单位受理信访举报的时间不同，信访人担心信访件未被受理或重视不够，在等待的过程中重复反映问题，导致重复访数量居高不下。2019年越级访15件次，同比下降57.14%。主要原因是枣阳市纪委监委领导班子认真执行定期下访接访制度，主要领导每周四固定接访，去年共接待群众面访36批次581人次，上访对象无一人越级访，有效缓解了全市大信访压力，越级访乱象得到了遏止；二是自办案件增加，上级转交件下降。2019年共受理信访举报995件，同比基本持平。其中本级自收573件，占57.59%，同比增长57.85%；上级转交办422件，占42.41%，同比下降33.02%。主要原因是随着全面从严治党不断向纵深推进，信访干部履职尽责意识不断增强，办信办访能力增强，加之信访渠道的通畅及日益拓宽，干部主动接访、带案下访、重点约访的机制发挥了积极作用，群众在本级信访诉求能够得到有效解决，越级向上反映问题大幅减少。三是信访反映村级干部增加，乡科级干部减少。2019年信访反映村（社区）人员419件，同比增长16.06%，反映乡科级干部198件，同比下降30.5%。从中不难看出在全面从严治党的高压态势下，不敢腐的震慑已经形成，不能腐的笼子正在扎牢，不想腐的自觉逐步增强，但从村干部信访举报持续增长的趋势显示，全面从严治党“最后一米”的问题还不够彻底，违反群众纪律和廉洁纪律类问题仍然居高不下，破坏了党群干群关系，蚕食了群众切身利益。 闵翼飞）</h3>
        <h3>
          <b>3.枣阳市新市镇原四级主任科员陈晖挪用公款、对危房改造工作监管不严等问题。</b>
        </h3>
        <h3>2013年4月，陈晖利用职务便利，挪用公款用于个人家庭开支，直至2016年9月枣阳市纪委调查时才归还；2015年8月起，陈晖私自保管新市镇泉商工业园拆迁工作经费收支票据不入账，直至2017年枣阳市纪委调查时才将收支票据提交给调查组；2015年，陈晖在新市镇分管城建工作期间，对李楼村危房改造工作监管不严，致使该村原党支部书记、村委会主任李某某（另案处理）虚假申报10户危房改造，套取补助资金，给国家造成经济损失；陈晖还涉嫌其他违法问题。2017年12月，陈晖受到开除党籍处分；2020年4月，陈晖受到政务撤职处分，由四级主任科员降为二级科员。</h3>
        <h3>
          <b>4.枣阳市国库收付局工作人员徐刚提供虚假证明文件，致使国有资产遭受损失问题。</b>
        </h3>
        <h3>2007年6月，徐刚在离岗创业，担任襄阳中兴达评估事务所注册资产评估师期间，参与原枣阳市棉花总公司破产清算，故意对该公司位于枣阳市火车站的棉花储备仓库土地及所属房产进行低价评估，并提供相应资产评估报告，致使国有资产损失，其行为构成提供虚假证明文件罪，但犯罪情节轻微，被法院判处免予刑事处罚。2020年4月，枣阳市纪委拟给予徐刚党内严重警告、政务降级处分。（枣阳市纪委监委）</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      PicBannertest1: require("../../../../assets/image/bannertest1.jpg"),
      PicBannertest2: require("../../../../assets/image/bannertest2.jpg")
    };
  },
  methods: {
    GoreportInternet() {
      this.$router.push("/forum");
    },
    GoreportEvaluation() {
      this.$router.push({ name: "forumWarning" });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
  padding-bottom: 14px;
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
   text-align: center;
  display: flex;
  justify-content: center;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
  margin-bottom: 30px;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}
.text h3 b {
  display: block;
  margin-top: 20px;
}
img{
  margin: 20px 0px;
}
.mg-16{
  margin: 0px 16px;
}
</style>